'use client';

import { createContext, useContext, useState, ReactNode } from 'react';
import { VerificationCheckResult } from '@/entities/verification-result';

interface VerificationResultContextValue {
    result: VerificationCheckResult | null;
    setResult: (result: VerificationCheckResult | null) => void;
    clearResult: () => void;
}

const VerificationResultContext = createContext<VerificationResultContextValue | null>(null);

export function VerificationResultProvider ({ children }: { children: ReactNode }) {
    const [ result, setResult ] = useState<VerificationCheckResult | null>(null);

    const clearResult = () => setResult(null);

    return (
        <VerificationResultContext.Provider value={ { result, setResult, clearResult } }>
            { children }
        </VerificationResultContext.Provider>
    );
}

export function useVerificationResult () {
    const ctx = useContext(VerificationResultContext);
    if (!ctx) {
        throw new Error('useVerificationResult must be used within VerificationResultProvider');
    }
    return ctx;
}
